import { memo } from 'react'
import { SxProps } from '@mui/material'
import { Box } from '@/components/Layout'
import { checkboxIconStyles as styles } from './CheckboxIcon.style'
import { CheckThickIcon } from '@/assets'

function CheckboxIconBase() {
  return <Box sx={styles.checkboxIcon} />
}

function CheckboxCheckedIconBase() {
  return (
    <Box sx={[styles.checkboxIcon, styles.checkedIconWrapper] as SxProps}>
      <Box component={CheckThickIcon} sx={styles.checkedIcon} />
    </Box>
  )
}

const MemoCheckboxIcon = memo(CheckboxIconBase)
const MemoCheckboxCheckedIcon = memo(CheckboxCheckedIconBase)
export { MemoCheckboxIcon as CheckboxIcon, MemoCheckboxCheckedIcon as CheckboxCheckedIcon }
